module.exports = __webpack_public_path__ + "static/media/instruction03.c6dc6bf0.png";